import { ApiModule } from './../api/api.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { PagerComponent } from './pager/pager.component';
import { DownloadDirective } from './download.directive';
import { EnumPipe } from './enum.pipe';
import { HighlightSearchPipe } from './highlight-search/highlights-search.pipe';
import { StoreImageUploadComponent } from './store-image-upload/store-image-upload.component';
import { TranslateModule } from '@ngx-translate/core';
import { DisableControlDirective } from './disable-control.directive';
import { LocalizedDatePipe } from './localized-date.pipe';
import { LocalizedCurrencyPipe } from './localized-currency.pipe';
import { FormatPrice } from './format-price.pipe';
import { HelpIconComponent } from './help-icon/help-icon.component';
import { PriceInputComponent } from './price-input/price-input.component';
import { PreventDoubleClickDirective } from './directives/prevent-double-click.directive';
import { NotificationSoundDirective } from './directives/notification-sound.directive';
import { NgxTrimDirective, NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MonthDatePickerComponent } from './month-date-picker/month-date-picker.component';
import { DayDatePickerComponent } from './day-date-picker/day-date-picker.component';
import { GoTimepickerComponent } from './go-timepicker/go-timepicker.component';
import { AuthEffects } from '../auth/+state/auth.effects';
import { AUTH_LOCAL_STORAGE_KEY, AUTH_STORAGE_KEYS, AUTH_CONFIG_TOKEN } from '../auth/auth.tokens';
import { LocalStorageService } from '../local-storage.service';
import { storageMetaReducer } from '../storage.metareducer';
import { UserLoginComponent } from './user-login/user-login.component';
import { GoogleSigninButtonModule } from '@abacritt/angularx-social-login';
import { CommonFormModule } from "./common-form/common-form.module";
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { LoadingPanelComponent } from './loading-panel/loading-panel.component';
import { PreventEnterDirective } from './directives/prevent-enter.directive';
import { CustomGoogleDirective } from './custom-google.directive';
import { GoToast } from './go-toast.component';
import { InviteUserDialogComponent } from './invite-user-dialog/invite-user-dialog.component';
import { CustomDatepickerComponent } from '../stores/custom-datepicker/custom-datepicker.component';
import { AllergensComponent } from './allergens/allergens.component';
import { TopCatalogViewComponent } from './top-catalog-view/top-catalog-view.component';
import { OfferPriceComponent } from './offer-price/offer-price.component';
import { OfferActionsComponent } from './offer-actions/offer-actions.component';
import { ViewOrderButtonComponent } from './view-order-button/view-order-button.component';
import { SafePipe } from "./safe.pipe";
import { ApiTokenGenerateComponent } from './api-token-generate/api-token-generate.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { InputTextComponent } from './input-text/input-text.component';
import { FormattedTimePipe } from './formatted-time.pipe';
import { TermsPrivacyComponent } from './terms-privacy/terms-privacy.component';
import { AsideToggleDirective, HtmlAttributesDirective, SidebarToggleDirective } from './coreui-fixture/shared/layout/layout.directive';
import { CollapsePanelComponent } from './collapse-panel/collapse-panel.component';
import { ButtonComponent } from './button/button.component';
import { AvatarComponent } from './avatar/avatar.component';
import { DialogComponent } from './dialog/dialog.component';
import { DialogActionsComponent } from './dialog/dialog-actions/dialog-actions.component';
import { DialogContentComponent } from './dialog/dialog-content/dialog-content.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './dialog/confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from './dialog/alert-dialog/alert-dialog.component';
import {ImageUploadComponent} from "./image-upload/image-upload.component";

export function getAuthConfig(saveKeys: string, localStorageKey: string, storageService: LocalStorageService) {
  return {
    metaReducers: [storageMetaReducer(({ tokens }) => ({ tokens }), localStorageKey, storageService)]
  };
}

@NgModule({ declarations: [
        PagerComponent, DownloadDirective, EnumPipe, HighlightSearchPipe,
        StoreImageUploadComponent, DisableControlDirective, LocalizedDatePipe, LocalizedCurrencyPipe,
        HelpIconComponent, FormatPrice, PriceInputComponent, PreventDoubleClickDirective,
        NotificationSoundDirective, MonthDatePickerComponent, DayDatePickerComponent, GoTimepickerComponent,
        UserLoginComponent, PhoneInputComponent, LoadingPanelComponent, PreventEnterDirective, CustomGoogleDirective,
        InviteUserDialogComponent, ImageUploadComponent,
        GoToast, CustomDatepickerComponent, AllergensComponent, TopCatalogViewComponent, OfferPriceComponent, OfferActionsComponent,
        ViewOrderButtonComponent, SafePipe, ApiTokenGenerateComponent, InputTextComponent, FormattedTimePipe, TermsPrivacyComponent,
        CollapsePanelComponent, ButtonComponent, AvatarComponent, DialogComponent, DialogActionsComponent, DialogContentComponent,
        ConfirmDialogComponent, AlertDialogComponent
    ],
    exports: [
        PagerComponent, DownloadDirective, EnumPipe, HighlightSearchPipe, StoreImageUploadComponent,
        TranslateModule, DisableControlDirective, LocalizedDatePipe, LocalizedCurrencyPipe,
        HelpIconComponent, FormatPrice, PriceInputComponent, PreventDoubleClickDirective,
        NotificationSoundDirective, NgxTrimDirective, MonthDatePickerComponent, DayDatePickerComponent, GoTimepickerComponent,
        UserLoginComponent, CommonFormModule, PhoneInputComponent, LoadingPanelComponent, PreventEnterDirective, CustomGoogleDirective,
        GoToast, CustomDatepickerComponent, AllergensComponent, TopCatalogViewComponent, OfferPriceComponent, OfferActionsComponent,
        ViewOrderButtonComponent, SafePipe, InputTextComponent, FormattedTimePipe, TermsPrivacyComponent,
        SidebarToggleDirective, AsideToggleDirective, HtmlAttributesDirective, CollapsePanelComponent, ButtonComponent, AvatarComponent,
        DialogComponent, DialogActionsComponent, DialogContentComponent, ConfirmDialogComponent, AlertDialogComponent,
        ImageUploadComponent, MatSelectModule
    ], imports: [CommonModule,
        MatDatepickerModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        MatSelectModule,
        ApiModule,
        TranslateModule,
        NgxTrimDirectiveModule,
        GoogleSigninButtonModule,
        CommonFormModule,
        SidebarToggleDirective,
        AsideToggleDirective,
        HtmlAttributesDirective], providers: [
        FormatPrice,
        AuthEffects,
        { provide: AUTH_LOCAL_STORAGE_KEY, useValue: '__auth_storage__' },
        { provide: AUTH_STORAGE_KEYS, useValue: 'auth' },
        {
            provide: AUTH_CONFIG_TOKEN,
            deps: [AUTH_STORAGE_KEYS, AUTH_LOCAL_STORAGE_KEY, LocalStorageService],
            useFactory: getAuthConfig
        },
        DatePipe,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class SharedModule { }
